import React from 'react';
import { RouteIcon } from '@patternfly/react-icons';
import NetworkApplianceTab from './NetworkApplianceTab';

function GatewaysTab() {
  return (
    <NetworkApplianceTab
      resource="gateways"
      nounPlural="gateways"
      emptyIcon={RouteIcon}
      tableAriaLabel="Gateways list"
    />
  );
}

export default GatewaysTab;
